module.exports = __webpack_public_path__ + "img/logo-mini.5a66117b.png";